// ============================================================================
//  AppShell.tsx — NexusCorp ERP · UI Modernisation
//  Clean layout wrapper · Smooth page transitions
// ============================================================================
import { Outlet, useLocation } from 'react-router-dom'
import Sidebar from './Sidebar'
import Header from './Header'
import { useUIStore } from '@/stores/ui.store'
import ToastContainer from '@/components/ui/ToastContainer'

export default function AppShell() {
  const { sidebarOpen, setSidebarOpen } = useUIStore()
  const { pathname } = useLocation()

  return (
    <>
      <div className="flex h-screen bg-[var(--bg)]">
        {/* Mobile overlay */}
        {sidebarOpen && (
          <div
            className="lg:hidden fixed inset-0 z-20 bg-[var(--sb-bg)]/50 backdrop-blur-sm"
            onClick={() => setSidebarOpen(false)}
          />
        )}

        <Sidebar />

        {/* Main column */}
        <div className="flex-1 flex flex-col min-w-0 overflow-hidden bg-[var(--bg)]">
          <Header />
          <main className="flex-1 overflow-y-auto">
            <div className="max-w-[1320px] mx-auto w-full px-4 sm:px-6 py-4 sm:py-6 nx-page-enter" key={pathname}>
              <Outlet />
            </div>
          </main>
        </div>
      </div>
      <ToastContainer />
    </>
  )
}
